import React from "react";
import "./produk.scss";
import FnB from "../../../Media/fotoproduk/The Loop.webp";
import Invesment from "../../../Media/fotoproduk/Cascade.webp";
import Office from "../../../Media/fotoproduk/Capital Cove.webp";

import {HashLink} from "react-router-hash-link";

const produk = () => {
  const FnBwa = () => {
    const whatsappLink =
      "https://api.whatsapp.com/send/?phone=6282172727291&text=Halo%20Swandy,%20Saya%20bisa%20minta%20detail%20Katalog,%20Simulasi,%20dan%20Promo%20terbaru%20Produk%20Komersial%20BSD%20Gading%20Serpong%20(FnB)%20https://komersialbsdgadingserpong.com//&type=phone_number&app_absent=0";
    window.open(whatsappLink, "_blank");
  };
  const Investmentwa = () => {
    const whatsappLink =
      "https://api.whatsapp.com/send/?phone=6282172727291&text=Halo%20Swandy,%20Saya%20bisa%20minta%20detail%20Katalog,%20Simulasi,%20dan%20Promo%20terbaru%20Produk%20Komersial%20BSD%20Gading%20Serpong%20(Investment)%20https://komersialbsdgadingserpong.com//&type=phone_number&app_absent=0";
    window.open(whatsappLink, "_blank");
  };
  const Officewa = () => {
    const whatsappLink =
      "https://api.whatsapp.com/send/?phone=6282172727291&text=Halo%20Swandy,%20Saya%20bisa%20minta%20detail%20Katalog,%20Simulasi,%20dan%20Promo%20terbaru%20Produk%20Komersial%20BSD%20Gading%20Serpong%20(Office)%20https://komersialbsdgadingserpong.com//&type=phone_number&app_absent=0";
    window.open(whatsappLink, "_blank");
  };

  return (
    <div id="produk" className="produk-kensington">
      <div className="container">
        <div className="container-judul">Temukan Kebutuhan Bisnis Anda</div>

        <div className="container-produka">
          <div className="produk">
            <div className="containerprodukimg">
              <img src={FnB} alt={FnB} />
            </div>
            <div className="judulproduk">Food & Baverage</div>
            <div className="judulproduk2">Cicilan Start</div>

            <HashLink className="link" smooth to="/FnB">
              Learn More
            </HashLink>
            <button className="buttonpenawaran" onClick={FnBwa}>
              Whatsapp
            </button>
          </div>
          <div className="produk">
            <div className="containerprodukimg">
              <img src={Invesment} alt={Invesment} />
            </div>
            <div className="judulproduk">Investment</div>
            <div className="judulproduk2">Cicilan Start</div>

            <HashLink className="link" smooth to="/Investment">
              Learn More
            </HashLink>
            <button className="buttonpenawaran" onClick={Investmentwa}>
              Whatsapp
            </button>
          </div>
          <div className="produk">
            <div className="containerprodukimg">
              <img src={Office} alt={Office} />
            </div>
            <div className="judulproduk">Office</div>
            <div className="judulproduk2">Cicilan Start</div>

            <HashLink className="link" smooth to="/Office">
              Learn More
            </HashLink>
            <button className="buttonpenawaran" onClick={Officewa}>
              Whatsapp
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default produk;
